module.exports = __webpack_public_path__ + "img/logo.58e1eecf.png";